import React, { Component } from 'react';
import Course from './Course/Course';
import Aux from '../../Hoc/Aux/Aux';
import classes from './Courses.css';
import CoursesData from '../../CoursesData';


class Courses extends  Component {

    render() {
        // console.log('[course]', CoursesData);

        const coursesObject = CoursesData.map(course => {
            return (
                <Course title={course.title} id={course.id} icon={course.icon} content={course.content} key={course.id}/>
            )
        });
        // console.log('[coursesObject]', coursesObject);
        return(
            <Aux>
                <div className="container">
                    <div className={classes.Wrapper}>
                        { coursesObject }
                    </div>
                </div>
            </Aux>
        )
    }
};

export default Courses;


// WEBPACK FOOTER //
// ./src/Components/Courses/Courses.js